// extracted by mini-css-extract-plugin
export default {"PointsWindow":"PointsWindow_PointsWindow__zsPoZ"};